import { render, staticRenderFns } from "./datEmbededViewComplaintsTable.vue?vue&type=template&id=a01629dc"
import script from "./datEmbededViewComplaintsTable.vue?vue&type=script&lang=js"
export * from "./datEmbededViewComplaintsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports